import script from "./AdminNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNavigation.vue?vue&type=script&setup=true&lang=js"

import "./AdminNavigation.vue?vue&type=style&index=0&id=e6e442ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6e442ea"]])

export default __exports__